import React from 'react';

type RadioInputProps = {
  className?: string;
  name: string;
  disabled?: boolean;
  error?: boolean;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  [x: string]: any;
};

function RadioInput({
  className,
  name,
  disabled,
  error,
  checked,
  value,
  onChange,
  ...props
}: RadioInputProps) {
  return (
    <input
      {...props}
      style={{ boxShadow: 'none' }}
      className={`${className} ${error ? 'text-river-red !border-river-red' : ''}`}
      type="radio"
      name={name}
      aria-label={name}
      disabled={disabled}
      value={value}
      onChange={onChange}
      checked={checked}
    />
  );
}

export default RadioInput;
